import { render, staticRenderFns } from "./DataChoose.vue?vue&type=template&id=518645a0&scoped=true&"
import script from "./DataChoose.vue?vue&type=script&lang=js&"
export * from "./DataChoose.vue?vue&type=script&lang=js&"
import style0 from "./DataChoose.vue?vue&type=style&index=0&id=518645a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518645a0",
  null
  
)

export default component.exports